import { render, staticRenderFns } from "./CmdrMaterials.vue?vue&type=template&id=301907d6&"
import script from "./CmdrMaterials.vue?vue&type=script&lang=js&"
export * from "./CmdrMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports